import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Block from '../block/Block';
import AriaLiveMessage from '../aria-live/AriaLiveMessage';
import SpinnerIcon from '../icons/spinner-icon/SpinnerIcon';
import useStrings from '../hooks/use-strings';
import { enableAriaAppHider, disableAriaAppHider } from '../../lib/aria-app-hider/aria-app-hider';
import { blockScrolling, unblockScrolling } from '../../lib/scroll-blocker/scroll-blocker';
import { getClasses } from '../../lib/style-utils/style-utils';
import styles from './WorkingOverlay.less';

var onKeyDown = function onKeyDown(event) {
  return 'Tab' === event.key && event.preventDefault();
};

var WorkingOverlay = function WorkingOverlay(_ref) {
  var showSpinner = _ref.showSpinner,
      _ref$messageId = _ref.messageId,
      messageId = _ref$messageId === void 0 ? 'global.working' : _ref$messageId,
      _ref$overlayDelay = _ref.overlayDelay,
      overlayDelay = _ref$overlayDelay === void 0 ? 0 : _ref$overlayDelay;

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var _useState = useState(getString(messageId)),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      translucent = _useState4[0],
      setTranslucent = _useState4[1];

  var overlayRef = useRef();
  var transitioned = useRef(false);
  var containerRef = useRef(document.createElement('div'));
  var modalRootRef = useRef(document.getElementById('app-modal-root'));
  useEffect(function () {
    var timeout;

    if (!transitioned.current) {
      transitioned.current = true;
      timeout = setTimeout(function () {
        setTranslucent(false);
      }, overlayDelay);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [overlayDelay]);
  useEffect(function () {
    var overlay = overlayRef.current;
    var container = containerRef.current;
    var modalRoot = modalRootRef.current;
    enableAriaAppHider();
    blockScrolling(overlay);
    modalRoot.appendChild(container);
    document.addEventListener('keydown', onKeyDown); // Causes the 'working' message to be repeated by screen readers

    var interval = setInterval(function () {
      setMessage(function (_message) {
        return _message + ' ';
      });
    }, 5000);
    return function () {
      clearInterval(interval);
      document.removeEventListener('keydown', onKeyDown);
      disableAriaAppHider();
      unblockScrolling(overlay);
      modalRoot.removeChild(container);
    };
  }, []);
  var classNames = getClasses({
    styles: styles,
    classes: ['overlay', translucent && 'translucent', overlayDelay && 'transition']
  });
  var spinnerClassNames = getClasses({
    styles: styles,
    classes: ['spinner', translucent && 'translucent']
  });
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Block, {
    className: classNames,
    elementRef: overlayRef,
    onKeyDown: onKeyDown,
    "data-testid": "overlay"
  }, showSpinner && transitioned.current && /*#__PURE__*/React.createElement("div", {
    className: spinnerClassNames
  }, /*#__PURE__*/React.createElement(SpinnerIcon, null), /*#__PURE__*/React.createElement(AriaLiveMessage, {
    "aria-live": "assertive",
    message: message
  }))), containerRef.current);
};

WorkingOverlay.propTypes = {
  showSpinner: PropTypes.bool,
  messageId: PropTypes.string
};
export default WorkingOverlay;